@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/colours.variables' as colours;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/2-tools/functions/global.functions' as globalFunctions;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/global.variables' as globalVariables;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/spacing.variables' as spacing;

.ontario-task-list {
	border-top: globalFunctions.px-to-rem(2) solid colours.$ontario-greyscale-20;
	padding: spacing.$spacing-0;
	margin: spacing.$spacing-0 spacing.$spacing-2;
}

.ontario-task-list__item {
	max-width: globalVariables.$full-width;
	list-style-type: none;
}
